export default __webpack_public_path__ + "static/media/react.86c8d9eb.png";